var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.messageDialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.messageDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "notification-container" },
            [
              _c("div", { staticClass: "header" }, [
                _c("h2", [_vm._v("消息通知")]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.markAllAsRead },
                      },
                      [_vm._v("全部标记为已读")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.filteredNotifications.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.filteredNotifications, function (notification) {
                      return _c(
                        "div",
                        {
                          key: notification.id,
                          staticClass: "notification-item",
                          class: { unread: !notification.readStatus == 1 },
                        },
                        [
                          _c("div", { staticClass: "notification-content" }, [
                            _c("div", { staticClass: "notification-title" }, [
                              _vm._v(_vm._s(notification.content)),
                            ]),
                            _c("div", { staticClass: "notification-time" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dateFormatYMDHMS(
                                    new Date(notification.createTime),
                                    "-"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "notification-actions" },
                            [
                              !notification.readStatus == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.markAsRead(notification)
                                        },
                                      },
                                    },
                                    [_vm._v("标记已读")]
                                  )
                                : _vm._e(),
                              notification.messageType == 3 &&
                              notification.oprationStatus == 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.agreeInquiry(notification)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(notification.oprationBtuName)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#f56c6c" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteNotification(
                                        notification
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "empty-state" }, [
                    _c("div", { staticClass: "empty-icon" }, [
                      _c("i", { staticClass: "el-icon-bell" }),
                    ]),
                    _c("p", [_vm._v("暂无消息")]),
                  ]),
              _c("Pagination", {
                attrs: {
                  currentPage: _vm.page,
                  pageSizes: [10, 20, 30, 40],
                  parentPageSize: _vm.size,
                  totalNumber: _vm.totalNumber,
                },
                on: { loadTable: _vm.getMessageList },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }